import { ref, readonly } from 'vue';

const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0 || ('msMaxTouchPoints' in navigator && typeof navigator.msMaxTouchPoints === 'number' && navigator.msMaxTouchPoints > 0);
const yScrollPosition = ref(window.scrollY);
const windowHeight = ref(window.innerHeight);
const clientWidth = ref(document.body.clientWidth);

window.addEventListener('scroll', () => {
  yScrollPosition.value = window.scrollY;
});

window.addEventListener('resize', () => {
  windowHeight.value = window.innerHeight;
});

const bodyObserver = new ResizeObserver(() => {
  clientWidth.value = document.body.clientWidth;
});

bodyObserver.observe(document.body);

export function useDocumentProperties() {
  return {
    isTouchDevice,
    yScrollPosition: readonly(yScrollPosition),
    windowHeight: readonly(windowHeight),
    clientWidth: readonly(clientWidth)
  };
}
